import React from 'react';
import classes from './spring-logo.scss';
const SpringLogo = () => /*#__PURE__*/React.createElement("div", {
  className: classes.container
}, /*#__PURE__*/React.createElement("span", {
  className: classes.plus
}, "+"), /*#__PURE__*/React.createElement("div", {
  className: classes.image
}));
export default SpringLogo;